import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UnitCustomInput, UnitCustomUnits } from '@core/models/unit-custom.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnitService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/unit';

  public getCustomUnit(user: string): Observable<Array<UnitCustomUnits>> {
    return this.http.get<Array<UnitCustomUnits>>(this.baseUrl + '/get-custom/' + user);
  }

  public setCustomUnit(input: UnitCustomInput): Observable<Array<UnitCustomUnits>> {
    return this.http.post<Array<UnitCustomUnits>>(this.baseUrl + '/set-custom', input);
  }
}
